<section class="cloud-infrastructure-hero">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="hero-content">
                    <span class="hero-badge">Enterprise Cloud & Data Centers</span>
                    <h1 class="hero-title">About Insightful IT Services</h1>
                    <p class="hero-description">
                        Insightful IT Services is an India-first cloud and data
                        center provider delivering enterprise-grade compute,
                        storage, and managed services from Tier IV–ready Mumbai
                        and Tier III Noida facilities. We combine scalable,
                        secure infrastructure with 24/7 expert support so your
                        business can run mission-critical workloads with
                        confidence.
                    </p>

                    <div class="hero-actions">
                        <a
                            class="btn-primary-gradient me-3"
                            routerLink="/contact"
                        >
                            <i class="bx bx-phone"></i>
                            Contact Us
                        </a>
                        <a class="btn-outline-light" routerLink="/contact">
                            <i class="bx bx-phone"></i>
                            Get Consultation
                        </a>
                    </div>

                    <div class="hero-features">
                        <div class="feature-item">
                            <i class="bx bx-check-circle"></i>
                            <span>99.99% Uptime SLA</span>
                        </div>
                        <div class="feature-item">
                            <i class="bx bx-check-circle"></i>
                            <span>Mumbai & Noida DCs</span>
                        </div>
                        <div class="feature-item">
                            <i class="bx bx-check-circle"></i>
                            <span>24/7 Expert Support</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="hero-image">
                    <div class="image-decoration">
                        <div class="floating-card card-1">
                            <i class="bx bx-chip"></i>
                            <span>NVIDIA H100 GPU</span>
                        </div>
                        <div class="floating-card card-2">
                            <i class="bx bx-server"></i>
                            <span>550+ Servers Ready</span>
                        </div>
                        <div class="floating-card card-3">
                            <i class="bx bx-support"></i>
                            <span>24/7 Monitoring</span>
                        </div>
                    </div>
                    <img
                        src="assets/img/support-img.png"
                        alt="Cloud Infrastructure Services"
                        class="img-fluid main-image"
                    />
                </div>
            </div>
        </div>
    </div>
    <div class="hero-background-elements">
        <div class="bg-element element-1"></div>
        <div class="bg-element element-2"></div>
        <div class="bg-element element-3"></div>
    </div>
</section>

<!-- Company Overview Section -->
<section class="company-overview-section ptb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="overview-content">
                    <span class="section-badge">About Our Company</span>
                    <h2>
                        Leading Cloud Infrastructure
                        <span class="text-highlight">Provider in India</span>
                    </h2>
                    <p class="overview-description">
                        Insightful IT Services is at the forefront of cloud
                        computing innovation in India. We design, build, and
                        operate cloud infrastructure that helps digital-native,
                        mid-market, and enterprise organisations modernise
                        legacy environments, launch new platforms faster, and
                        meet stringent security and compliance expectations.
                    </p>

                    <div class="company-features">
                        <div class="feature-item">
                            <div class="feature-icon">
                                <i class="bx bx-shield-check"></i>
                            </div>
                            <div class="feature-content">
                                <h4>Hardened, Compliant Infrastructure</h4>
                                <p>
                                    Enterprise-grade security controls,
                                    structured change management, and auditable
                                    processes aligned with ISO 27001 and SOC 2
                                    best practices.
                                </p>
                            </div>
                        </div>

                        <div class="feature-item">
                            <div class="feature-icon">
                                <i class="bx bx-chip"></i>
                            </div>
                            <div class="feature-content">
                                <h4>Modern Cloud Platform</h4>
                                <p>
                                    Modern compute, storage, and networking
                                    platform with NVIDIA GPU options for AI/ML
                                    workloads and high-performance computing.
                                </p>
                            </div>
                        </div>

                        <div class="feature-item">
                            <div class="feature-icon">
                                <i class="bx bx-support"></i>
                            </div>
                            <div class="feature-content">
                                <h4>24/7 Expert Operations</h4>
                                <p>
                                    Round-the-clock technical support from
                                    certified cloud engineers with response
                                    times measured in minutes, not hours.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="overview-image">
                    <div class="image-wrapper">
                        <img
                            src="assets/img/solutions-img.png"
                            alt="Cloud Infrastructure"
                            class="img-fluid"
                        />

                        <div class="floating-stats">
                            <div class="stat-card card-1">
                                <div class="stat-number">550+</div>
                                <div class="stat-label">Servers</div>
                            </div>
                            <div class="stat-card card-2">
                                <div class="stat-number">99.99%</div>
                                <div class="stat-label">Uptime</div>
                            </div>
                            <div class="stat-card card-3">
                                <div class="stat-number">2</div>
                                <div class="stat-label">Data Centers</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Company Stats Section -->
<section class="stats-section ptb-100">
    <div class="container">
        <div class="section-title">
            <span class="section-badge">Our Achievements</span>
            <h2>
                Trusted by
                <span class="text-highlight">Businesses Across India</span>
            </h2>
            <p>
                Our cloud platform powers critical workloads for customers
                across SaaS, fintech, e‑commerce, healthcare, and manufacturing
                segments throughout India.
        </div>

        <div class="row">
            <div class="col-lg-3 col-md-6 col-6 mb-4">
                <div class="stat-item">
                    <div class="stat-icon">
                        <i class="bx bx-server"></i>
                    </div>
                    <div class="stat-number">550+</div>
                    <div class="stat-title">Active Servers</div>
                    <div class="stat-description">
                        High-performance servers ready for deployment
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-6 mb-4">
                <div class="stat-item">
                    <div class="stat-icon">
                        <i class="bx bx-buildings"></i>
                    </div>
                    <div class="stat-number">500+</div>
                    <div class="stat-title">Happy Clients</div>
                    <div class="stat-description">
                        Businesses trusting our cloud infrastructure
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-6 mb-4">
                <div class="stat-item">
                    <div class="stat-icon">
                        <i class="bx bx-time"></i>
                    </div>
                    <div class="stat-number">99.99%</div>
                    <div class="stat-title">Uptime SLA</div>
                    <div class="stat-description">
                        Guaranteed availability with enterprise SLA
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-6 mb-4">
                <div class="stat-item">
                    <div class="stat-icon">
                        <i class="bx bx-support"></i>
                    </div>
                    <div class="stat-number">24/7</div>
                    <div class="stat-title">Expert Support</div>
                    <div class="stat-description">
                        Round-the-clock technical assistance
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Technology & Innovation Section -->
<section class="technology-section ptb-100">
    <div class="container">
        <div class="section-title">
            <span class="section-badge">Technology Stack</span>
            <h2>
                Powered by <span class="text-highlight">Latest Technology</span>
            </h2>
            <p>
                Our cloud infrastructure is built on cutting-edge technology
                stack to ensure maximum performance, security, and reliability.
            </p>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6 mb-4">
                <div class="tech-card">
                    <div class="tech-icon">
                        <i class="bx bx-chip"></i>
                    </div>
                    <h3>NVIDIA GPU Computing</h3>
                    <p>
                        Latest NVIDIA H200, H100, and A100 GPUs for AI/ML
                        workloads, deep learning, and high-performance computing
                        applications.
                    </p>
                    <div class="tech-specs">
                        <span class="spec-tag">H200 GPU</span>
                        <span class="spec-tag">AI/ML Ready</span>
                        <span class="spec-tag">CUDA Support</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 mb-4">
                <div class="tech-card">
                    <div class="tech-icon">
                        <i class="bx bx-data"></i>
                    </div>
                    <h3>NVMe SSD Storage</h3>
                    <p>
                        Ultra-fast NVMe SSD storage with enterprise-grade
                        performance, ensuring rapid data access and superior I/O
                        operations.
                    </p>
                    <div class="tech-specs">
                        <span class="spec-tag">NVMe SSD</span>
                        <span class="spec-tag">High IOPS</span>
                        <span class="spec-tag">Low Latency</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 mb-4">
                <div class="tech-card">
                    <div class="tech-icon">
                        <i class="bx bx-network-chart"></i>
                    </div>
                    <h3>Enterprise Networking</h3>
                    <p>
                        Redundant network infrastructure with load balancing,
                        DDoS protection, and high-bandwidth connectivity across
                        data centers.
                    </p>
                    <div class="tech-specs">
                        <span class="spec-tag">Load Balancer</span>
                        <span class="spec-tag">DDoS Shield</span>
                        <span class="spec-tag">High Bandwidth</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 mb-4">
                <div class="tech-card">
                    <div class="tech-icon">
                        <i class="bx bx-shield-check"></i>
                    </div>
                    <h3>Advanced Security</h3>
                    <p>
                        Multi-layered security architecture with firewalls,
                        intrusion detection, encryption, and compliance with
                        industry standards.
                    </p>
                    <div class="tech-specs">
                        <span class="spec-tag">ISO 27001</span>
                        <span class="spec-tag">SOC 2</span>
                        <span class="spec-tag">Encryption</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 mb-4">
                <div class="tech-card">
                    <div class="tech-icon">
                        <i class="bx bx-mobile-alt"></i>
                    </div>
                    <h3>API & Automation</h3>
                    <p>
                        RESTful APIs and automation tools for seamless
                        integration, infrastructure as code, and programmatic
                        resource management.
                    </p>
                    <div class="tech-specs">
                        <span class="spec-tag">REST API</span>
                        <span class="spec-tag">Terraform</span>
                        <span class="spec-tag">DevOps Ready</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 mb-4">
                <div class="tech-card">
                    <div class="tech-icon">
                        <i class="bx bx-cog"></i>
                    </div>
                    <h3>Monitoring & Analytics</h3>
                    <p>
                        Real-time monitoring, performance analytics, and
                        intelligent alerting to ensure optimal resource
                        utilization and uptime.
                    </p>
                    <div class="tech-specs">
                        <span class="spec-tag">Real-time</span>
                        <span class="spec-tag">Analytics</span>
                        <span class="spec-tag">Smart Alerts</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="cloud-services-section ptb-100">
    <div class="container">
        <div class="section-title">
            <span class="section-badge">Complete Cloud Solutions</span>
            <h2>Enterprise Cloud Infrastructure Portfolio</h2>
            <p>
                Comprehensive cloud computing services designed to accelerate
                your digital transformation with cutting-edge technology,
                enterprise security, and scalable performance.
            </p>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6 mb-4">
                <div class="cloud-service-card featured">
                    <div class="service-header">
                        <div class="service-icon">
                            <i class="bx bx-chip"></i>
                        </div>
                        <div class="service-badge">Premium</div>
                    </div>
                    <div class="service-content">
                        <h3>GPU Cloud Computing</h3>
                        <p class="service-description">
                            High-performance NVIDIA H200, H100, A100 GPUs for
                            AI/ML workloads, deep learning, and scientific
                            computing with enterprise-grade infrastructure.
                        </p>

                        <div class="service-features">
                            <ul class="feature-list">
                                <li>
                                    <i class="bx bx-check"></i> NVIDIA H200/H100
                                    GPUs
                                </li>
                                <li>
                                    <i class="bx bx-check"></i> AI/ML optimized
                                    stacks
                                </li>
                                <li>
                                    <i class="bx bx-check"></i> Auto-scaling
                                    capabilities
                                </li>
                                <li>
                                    <i class="bx bx-check"></i> High-speed NVMe
                                    storage
                                </li>
                                <li>
                                    <i class="bx bx-check"></i> Dedicated GPU
                                    instances
                                </li>
                                <li>
                                    <i class="bx bx-check"></i> TIR AI/ML
                                    Platform
                                </li>
                            </ul>
                        </div>

                        <div class="service-specs">
                            <div class="spec-grid">
                                <div class="spec-item">
                                    <span class="spec-label">Engagement:</span>
                                    <span class="spec-value"
                                        >Talk to our solution team</span
                                    >
                                </div>
                                <div class="spec-item">
                                    <span class="spec-label">Deploy Time:</span>
                                    <span class="spec-value">Under 60 seconds</span>
                                </div>
                            </div>
                        </div>

                        <div class="service-actions">
                            <a
                                routerLink="/contact"
                                class="btn-primary-gradient"
                            >
                                <i class="bx bx-phone"></i>
                                Contact Us
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 mb-4">
                <div class="cloud-service-card">
                    <div class="service-header">
                        <div class="service-icon">
                            <i class="bx bxl-windows"></i>
                        </div>
                        <div class="service-badge infrastructure">
                            Infrastructure
                        </div>
                    </div>
                    <div class="service-content">
                        <h3>Windows Cloud</h3>
                        <p class="service-description">
                            Reliable Windows Server instances with full
                            administrator access, perfect for enterprise
                            applications and .NET workloads.
                        </p>

                        <div class="service-features">
                            <ul class="feature-list">
                                <li>
                                    <i class="bx bx-check"></i> Windows Server
                                    2019/2022
                                </li>
                                <li>
                                    <i class="bx bx-check"></i> RDP remote
                                    access
                                </li>
                                <li>
                                    <i class="bx bx-check"></i> Enterprise
                                    applications
                                </li>
                                <li>
                                    <i class="bx bx-check"></i> SQL Server
                                    compatible
                                </li>
                                <li>
                                    <i class="bx bx-check"></i> Active Directory
                                    support
                                </li>
                                <li>
                                    <i class="bx bx-check"></i> Automated
                                    backups
                                </li>
                            </ul>
                        </div>

                        <div class="service-specs">
                            <div class="spec-grid">
                                <div class="spec-item">
                                    <span class="spec-label">Engagement:</span>
                                    <span class="spec-value"
                                        >Work with our architects</span
                                    >
                                </div>
                                <div class="spec-item">
                                    <span class="spec-label">Uptime SLA:</span>
                                    <span class="spec-value">99.99%</span>
                                </div>
                            </div>
                        </div>

                        <div class="service-actions">
                            <a
                                routerLink="/contact"
                                class="btn-primary-gradient"
                            >
                                <i class="bx bx-phone"></i>
                                Contact Us
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 mb-4">
                <div class="cloud-service-card">
                    <div class="service-header">
                        <div class="service-icon">
                            <i class="bx bxl-tux"></i>
                        </div>
                        <div class="service-badge security">Performance</div>
                    </div>
                    <div class="service-content">
                        <h3>Linux Cloud</h3>
                        <p class="service-description">
                            High-performance Linux instances with multiple
                            distributions, SSH access, and full root privileges
                            for maximum flexibility.
                        </p>

                        <div class="service-features">
                            <ul class="feature-list">
                                <li>
                                    <i class="bx bx-check"></i> Ubuntu, CentOS,
                                    RHEL
                                </li>
                                <li>
                                    <i class="bx bx-check"></i> SSH root access
                                </li>
                                <li>
                                    <i class="bx bx-check"></i> Docker &
                                    Kubernetes
                                </li>
                                <li>
                                    <i class="bx bx-check"></i> Custom
                                    configurations
                                </li>
                                <li>
                                    <i class="bx bx-check"></i> High-performance
                                    CPUs
                                </li>
                                <li>
                                    <i class="bx bx-check"></i> NVMe SSD storage
                                </li>
                            </ul>
                        </div>

                        <div class="service-specs">
                            <div class="spec-grid">
                                <div class="spec-item">
                                    <span class="spec-label">Contact Us:</span>
                                    <span class="spec-value"
                                        >For Pricing Details</span
                                    >
                                </div>
                                <div class="spec-item">
                                    <span class="spec-label">Deploy Time:</span>
                                    <span class="spec-value">Under 30 seconds</span>
                                </div>
                            </div>
                        </div>

                        <div class="service-actions">
                            <a
                                routerLink="/contact"
                                class="btn-primary-gradient"
                            >
                                <i class="bx bx-phone"></i>
                                Contact Us
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="location-area ptb-100">
    <div class="container">
        <div class="section-title">
            <h2>Data Center <span class="text-highlight">Locations</span></h2>
            <p>
                Strategic data center locations in Mumbai and Noida providing
                high-performance infrastructure with low-latency access across
                India.
            </p>
        </div>

        <div class="data-center-tiles">
            <div class="row">
                <div class="col-lg-6 col-md-6">
                    <div class="data-center-tile">
                        <div class="tile-header">
                            <div class="indian-flag">
                                <div class="flag-stripe saffron"></div>
                                <div class="flag-stripe white"></div>
                                <div class="flag-stripe green"></div>
                            </div>
                            <div class="tile-icon">
                                <i class="bx bx-buildings"></i>
                            </div>
                        </div>
                        <div class="tile-content">
                            <h3>Mumbai Data Center</h3>
                            <p class="location-info">
                                <i class="bx bx-map"></i>
                                <span>Maharashtra, India</span>
                            </p>
                            <div class="server-count">
                                <span class="count">300+</span>
                                <span class="label">Active Servers</span>
                            </div>
                            <div class="features">
                                <span class="feature-tag">Western Coast</span>
                                <span class="feature-tag">Low Latency</span>
                                <span class="feature-tag">24/7 Support</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 col-md-6">
                    <div class="data-center-tile">
                        <div class="tile-header">
                            <div class="indian-flag">
                                <div class="flag-stripe saffron"></div>
                                <div class="flag-stripe white"></div>
                                <div class="flag-stripe green"></div>
                            </div>
                            <div class="tile-icon">
                                <i class="bx bx-buildings"></i>
                            </div>
                        </div>
                        <div class="tile-content">
                            <h3>Noida Data Center</h3>
                            <p class="location-info">
                                <i class="bx bx-map"></i>
                                <span>Uttar Pradesh, India</span>
                            </p>
                            <div class="server-count">
                                <span class="count">250+</span>
                                <span class="label">Active Servers</span>
                            </div>
                            <div class="features">
                                <span class="feature-tag">Northern Region</span>
                                <span class="feature-tag"
                                    >High Performance</span
                                >
                                <span class="feature-tag"
                                    >Enterprise Grade</span
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="cta-section ptb-100">
    <div class="container">
        <div class="cta-content-wrapper">
            <div class="row align-items-center">
                <div class="col-lg-8">
                    <div class="cta-content">
                        <h2>
                            Transform Your Business with Cloud Infrastructure
                        </h2>
                        <p class="cta-description">
                            Join hundreds of businesses across India who trust
                            our enterprise-grade cloud infrastructure. Deploy in
                            60 seconds with 99.99% uptime guarantee and 24/7
                            expert support from our Mumbai and Noida data
                            centers.
                        </p>

                        <div class="cta-features">
                            <div class="feature-item">
                                <i class="bx bx-rocket"></i>
                                <span>Deploy in 60 seconds</span>
                            </div>
                            <div class="feature-item">
                                <i class="bx bx-support"></i>
                                <span>24/7 Expert Support</span>
                            </div>
                            <div class="feature-item">
                                <i class="bx bx-badge-check"></i>
                                <span>99.99% Uptime SLA</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="cta-actions">
                        <a class="btn-cta-primary" routerLink="/contact">
                            <i class="bx bx-cloud"></i>
                            <span>Contact Us</span>
                            <small>Get in touch</small>
                        </a>
                        <a class="btn-cta-secondary" routerLink="/contact">
                            <i class="bx bx-phone"></i>
                            <span>Schedule Demo</span>
                            <small>See our platform</small>
                        </a>

                        <div class="cta-guarantee">
                            <i class="bx bx-badge-check"></i>
                            <span>99.99% Uptime Guaranteed</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="cta-background-elements">
        <div class="bg-element element-1"></div>
        <div class="bg-element element-2"></div>
        <div class="bg-element element-3"></div>
        <div class="bg-element element-4"></div>
    </div>
</section>

<div class="brand-area pt-100 pb-70">
    <div class="container">
        <div class="row">
            <div class="brand-wrap owl-carousel owl-theme">
                <div class="single-brand">
                    <img
                        src="assets/img/brand-logo/brand-logo-one.png"
                        alt="Partner logo one"
                    />
                </div>

                <div class="single-brand">
                    <img
                        src="assets/img/brand-logo/brand-logo-two.png"
                        alt="Partner logo two"
                    />
                </div>

                <div class="single-brand">
                    <img
                        src="assets/img/brand-logo/brand-logo-three.png"
                        alt="Partner logo three"
                    />
                </div>

                <div class="single-brand">
                    <img
                        src="assets/img/brand-logo/brand-logo-four.png"
                        alt="Partner logo four"
                    />
                </div>

                <div class="single-brand">
                    <img
                        src="assets/img/brand-logo/brand-logo-five.png"
                        alt="Partner logo five"
                    />
                </div>
            </div>
        </div>
    </div>
</div>
